import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "@/components/feature/SearchBar";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="flex items-center h-16 gap-6">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
              CC
            </span>
            <span className="font-heading font-bold text-xl text-foreground-950 tracking-wide">
              CC视频
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-2">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(item.to)
                    ? "text-primary-700 bg-primary-50 font-medium"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:block ml-auto w-72">
            <SearchBar size="sm" />
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 ccv-fade">
          <div className="max-w-content mx-auto px-4 py-4 flex flex-col gap-3">
            <SearchBar size="sm" onNavigate={() => setOpen(false)} />
            <div className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setOpen(false)}
                  className={`px-3 py-2.5 rounded-md text-sm text-center whitespace-nowrap cursor-pointer ${
                    isActive(item.to)
                      ? "bg-primary-500 text-background-50 font-medium"
                      : "bg-background-100 text-foreground-800"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}